import axios, { AxiosError } from 'axios';
import { message } from 'antd';
import { useAuthStore } from '../store/auth';

const attachAuth = (config: any) => {
  const token = useAuthStore.getState().token;
  if (token) {
    config.headers.set('Authorization', `Bearer ${token}`);
  }
  return config;
};

const handleAuthError = (err: AxiosError<any>) => {
  const url = err.config?.url ?? '';
  const isLoginRequest = url.includes('/auth/simple-login') || url.includes('/auth/dev-login');
  if (err.response?.status === 401 && !isLoginRequest) {
    useAuthStore.getState().clear();
    window.location.href = '/login';
    return Promise.reject(err);
  }
  const msg = err.response?.data?.message || err.message;
  message.error(typeof msg === 'string' ? msg : JSON.stringify(msg));
  return Promise.reject(err);
};

/**
 * 原始 axios 实例，不解包响应（适合 blob 下载等场景）。
 */
export const http = axios.create({
  baseURL: '/api',
  timeout: 30_000,
});
http.interceptors.request.use(attachAuth);
http.interceptors.response.use((r) => r, handleAuthError);

/**
 * 业务 axios 实例，自动解包 {ok, data, ...} 信封。
 */
export const api = axios.create({
  baseURL: '/api',
  timeout: 15_000,
});
api.interceptors.request.use(attachAuth);
api.interceptors.response.use(
  (resp) => {
    if (resp.data && typeof resp.data === 'object' && 'ok' in resp.data) {
      if (resp.data.ok) return resp.data.data ?? null;
      throw new Error((resp.data as any).message || '请求失败');
    }
    return resp.data;
  },
  handleAuthError,
);

export type Page<T> = { items: T[]; total: number; page: number; size: number };

/** 钉钉全量同步、大文件导出等长耗时接口（须与 nginx proxy_read_timeout 对齐） */
export const LONG_RUNNING_TIMEOUT_MS = 300_000;
